import { Seo } from "gatsby-theme-grape-blog/src/components/seo"
import { PAGE_TYPES } from "gatsby-theme-grape-blog/src/utils/schema-org"
import React from "react"
import { Alert } from "../components/basic"
import { ContactForm } from "../components/contact-form"
import { Header, H1 } from "../components/header"
import Layout, { Main, OneColumn } from "../components/layout"

const SuccessAlert = ({ show }) => {
  return (
    <Alert show={show} type="success">
      <strong>Thank you!</strong> I will get back to you shortly.
    </Alert>
  )
}

const ContactPage = () => {
  return (
    <Layout>
      <Seo
        title="Invite me to speak at your gym"
        schemaOrgType={PAGE_TYPES.CONTACT}
      />
      <Header>
        <H1>Invite me to speak at your gym</H1>
      </Header>
      <OneColumn>
        <Main>
          <h2>Send a message</h2>
          <ContactForm
            topContent={(context, { isSuccess }) => (
              <>
                {!isSuccess && (
                  <p>
                    For speaking invitations, workshops, podcast questions, or
                    topic requests, send a short note and I&apos;ll get back to
                    you.
                  </p>
                )}
                <SuccessAlert show={isSuccess} />
              </>
            )}
          />
        </Main>
      </OneColumn>
    </Layout>
  )
}

export default ContactPage
